import React from "react";
import Home from "./pages/Home";
import SEO from './components/SEO';

function App() {
  return (
    <>
      <SEO />
      <Home />
    </>
  );
}

export default App;
